import { render, staticRenderFns } from "./left-modal.vue?vue&type=template&id=2bd3c5bb&scoped=true"
import script from "./left-modal.vue?vue&type=script&lang=js"
export * from "./left-modal.vue?vue&type=script&lang=js"
import style0 from "./left-modal.vue?vue&type=style&index=0&id=2bd3c5bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd3c5bb",
  null
  
)

export default component.exports